import { gql } from '@apollo/client';

export const CoreFriend = gql`
  fragment CoreFriend on UserType {
    _id
    fullName
    invitedBy
    email
    avatar
    isPro
    friends
    token
    enableChat
  }
`;

export const CoreUser = gql`
  fragment CoreUser on UserType {
    _id
    fullName
    invitedBy
    email
    avatar
    isPro
    friends
    token
    enableChat
    createdAt
    isISCH
    hasRequest
  }
`;
